import i18n from "@/i18n"
import React from "react"
import styled from "styled-components"
import { Trans } from "react-i18next"

const Card = styled.article`
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    min-width: 240px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 267px;
    padding: 20px 8px;
    ${props => props.isHighlighted && `
        border: 4px solid #83c308;
    `}
`

const Amount = styled.p`
    color: #222;
    font-size: 23px;
    line-height: 28px;
    letter-spacing: -0.46px;
    
    .price-value {
      letter-spacing: -0.64px;
    }
`

const Label = styled.p`
    color: #83c308;
    font-size: 22px;
    line-height: 1;
    letter-spacing: -0.44px;
    margin-top: 4px;
`

const Section = styled.section`
    display: flex;
    max-width: 900px;
    padding-bottom: 80px;
    flex-direction: column;
    align-items: center;
    font-weight: 800;
    text-align: center;
`

const Header = styled.header`
    background-color: #f1f1f1;
    display: flex;
    width: 100%;
    flex-direction: column;
    overflow: hidden;
    align-items: center;
    padding: 60px 20px 20px;
`

const Heading = styled.h1`
    font-size: 34px;
    color: #222;
    letter-spacing: -0.68px;
    line-height: 44px;
`

const Highlight = styled.span`
    color: #83c308;
`

const CardsContainer = styled.div`
    border-radius: 12px 12px 0 0;
    background-color: #f1f1f1;
    display: flex;
    width: 100%;
    gap: 10px;
    overflow: hidden;
    justify-content: center;
    flex-wrap: wrap;
    padding: 20px;
`

const Footer = styled.footer`
    border-radius: 0 0 12px 12px;
    background-color: #222;
    width: 100%;
    display: flex;
    flex-direction: column;
    color: #fff;
    justify-content: center;
    padding: 40px 20px 20px;
`

const FooterText = styled.p`
    font-size: 34px;
    line-height: 44px;
    letter-spacing: -0.68px;
    align-self: center;
    font-weight: 700;
`

const CallToAction = styled.button`
    border-radius: 8px;
    background-color: #83c308;
    margin: 40px 40px 20px 40px;
    min-height: 44px;
    font-size: 20px;
    letter-spacing: -0.4px;
    line-height: 1;
    padding: 9px 10px;
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: 600;
`

function PricingCard({ amount, emoji, label, isHighlighted }) {
    return (
        <Card isHighlighted={isHighlighted}>
            <Amount>
				<>{emoji}<br /></>
                <Trans i18nKey="common.landing.price.amount" values={{ amount }}>
                    <span className="price-value"/>
                </Trans>
            </Amount>
            <Label>{label}</Label>
        </Card>
    );
}

export default function PricingSection({ history }) {
    const pricingData = [
        {
            amount: "1,000",
			emoji: "💸💸💸",
            label: i18n.t("common.landing.price.label_1")
        },
        {
            amount: "500",
			emoji: "💸💸",
            label: i18n.t("common.landing.price.label_2")
        },
        {
            amount: "2",
			emoji: "🤑",
            label: i18n.t("common.landing.price.label_3"),
            isHighlighted: true
        }
    ]
    return (
        <Section>
            <Header>
                <Heading>
                    <Trans i18nKey="common.landing.price.heading">
                        <Highlight />
                        <br />
                    </Trans>
                </Heading>
            </Header>
            <CardsContainer>
                {pricingData.map((item, index) => (
                    <PricingCard
                        key={index}
						emoji={item.emoji}
                        amount={item.amount}
                        label={item.label}
                        isHighlighted={item.isHighlighted}
                    />
                ))}
            </CardsContainer>
            <Footer>
                <FooterText>
					<Trans i18nKey="common.landing.price.footer">
                        <br />
                    </Trans>
                </FooterText>
                <CallToAction onClick={() => history.push("/payment")}>
                    {i18n.t("common.landing.price.btn")}
                </CallToAction>
            </Footer>
        </Section>
    );
}